module.exports = __webpack_public_path__ + "static/media/Accademia - DK Chocolate_LT Grey.b325dc3c.jpg";